
import RequestAbstract from "../abstract";

export default class Banks extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/banks";
    }

}

